import { render, staticRenderFns } from "./NowhowTextbox.vue?vue&type=template&id=42b07dfe"
import script from "./NowhowTextbox.vue?vue&type=script&lang=ts"
export * from "./NowhowTextbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports